import {Component, OnInit} from '@angular/core';
import {RoutingState} from '../../shared/routing-state.service';

@Component({
  selector: 'app-samsung-toolbar',
  templateUrl: './samsung-toolbar.component.html',
  styleUrls: ['./samsung-toolbar.component.css']
})
export class SamsungToolbarComponent implements OnInit {

  constructor(private routerState: RoutingState) {
  }

  ngOnInit() {
  }

}
